//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { TrackingIdPrefix } from '@models/TrackingId';

export const MEDIA_LIBRARY_TRACKING_ID_PREFIX: TrackingIdPrefix =
  'media-library-';
export const MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX: TrackingIdPrefix =
  'media-library-filter-panel-';

export const MediaLibraryTrackingIds = {
  // Collection
  CLOSE_COLLECTION_MODAL: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}close-collection-modal`,
  CREATE_EMPTY_COLLECTION: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}create-empty-collection`,
  OPEN_CREATE_EMPTY_COLLECTION_MODAL: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}open-create-empty-collection-modal`,
  OPEN_SAVE_AS_COLLECTION_MODAL: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}open-save-as-collection-modal`,
  SAVE_AS_COLLECTION: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}save-as-collection`,
  // Sources modals
  ALL_TEAM_MEMBERS_MODAL_SEARCH_BAR: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}all-team-members-modal-search-bar`,
  ALL_TEAM_MEMBERS_MODAL_MANAGE_TEAM_MEMBERS_LINK: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}all-team-members-modal-manage-team-members-link`,
  ALL_TRACKED_HASHTAGS_MODAL_SEARCH_BAR: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}all-tracked-hashtags-modal-search-bar`,
  ALL_TRACKED_HASHTAGS_MODAL_MANAGE_TRACKED_HASHTAGS_LINK: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}all-tracked-hashtags-modal-manage-tracked-hashtags-link`,
  ALL_TRACKED_USERS_MODAL_SEARCH_BAR: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}all-tracked-users-modal-search-bar`,
  ALL_TRACKED_USERS_MODAL_MANAGE_TRACKED_USERS_LINK: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}all-tracked-users-modal-manage-tracked-users-link`,
  APPLY_ALL_TEAM_MEMBERS_MODAL: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}apply-all-team-members-modal`,
  APPLY_ALL_TRACKED_HASHTAGS_MODAL: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}apply-all-tracked-hashtags-modal`,
  APPLY_ALL_TRACKED_USERS_MODAL: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}apply-all-tracked-users-modal`,
  CLOSE_ALL_TEAM_MEMBERS_MODAL: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}close-all-team-members-modal`,
  CLOSE_ALL_TRACKED_HASHTAGS_MODAL: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}close-all-tracked-hashtags-modal`,
  CLOSE_ALL_TRACKED_USERS_MODAL: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}close-all-tracked-users-modal`,
  // Top bar
  SEARCH_TEXT_FILTER: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}search-text-filter`,
  SHOW_SUMMARY_BUTTON: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}show-summary-button`,
  SORT_TYPE_DROPDOWN: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}sort-type-dropdown`,
  SOURCES_DROPDOWN_SEARCH_BAR: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}sources-dropdown-search-bar`,
  TOGGLE_FILTER_PANEL: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}toggle-filter-panel`,
  TOGGLE_SOURCES_DROPDOWN: `${MEDIA_LIBRARY_TRACKING_ID_PREFIX}toggle-sources-dropdown`,
  // filter checkboxes
  LABELS_LABELED_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}labels-labeled-checkbox`,
  LABELS_NOT_LABELED_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}labels-not-labeled-checkbox`,
  MEDIA_TYPE_IMAGE_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}media-type-image-checkbox`,
  MEDIA_TYPE_VIDEO_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}media-type-video-checkbox`,
  MEDIA_TYPE_GIF_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}media-type-gif-checkbox`,
  ORIENTATION_VERTICAL_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}orientation-vertical-checkbox`,
  ORIENTATION_HORIZONTAL_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}orientation-horizontal-checkbox`,
  ORIENTATION_SQUARE_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}orientation-square-checkbox`,
  RIGHTS_OWNED_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}rights-owned-checkbox`,
  RIGHTS_APPROVED_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}rights-approved-checkbox`,
  RIGHTS_PENDING_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}rights-pending-checkbox`,
  RIGHTS_REJECTED_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}rights-rejected-checkbox`,
  RIGHTS_NONE_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}rights-none-checkbox`,
  SPAM_FILTERING_CHECKBOX: `${MEDIA_LIBRARY_FILTER_PANEL_TRACKING_ID_PREFIX}spam-filtering-checkbox`,
} as const;
